<template>
  <v-menu
    v-model="isOpenMenu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        clearable
        :value="computedDateFormatted"
        :label="label"
        prepend-icon="mdi-calendar"
        readonly
        @click:clear="
          date = [];
          inputHandler([]);
        "
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker range v-model="date" :max="maxDate" @input="inputHandler">
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment';
import { isBefore, parseISO } from 'date-fns';

export default {
  name: 'HistoryDatepickerRangeField',
  props: {
    modeSelection: {
      type: String,
      default: 'day'
    },
    isStart: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isOpenMenu: false,
      maxDate: '',
      date: []
    };
  },
  computed: {
    computedDateFormatted() {
      if (this.date.length === 1) {
        return this.date[0];
      }

      if (isBefore(parseISO(this.date[1]), parseISO(this.date[0]))) {
        return `${this.date[1]} — ${this.date[0]}`;
      } else {
        return `${this.date[0]} — ${this.date[1]}`;
      }
    }
  },
  methods: {
    inputHandler(e) {
      if (e.length === 2) {
        if (isBefore(parseISO(e[1]), parseISO(e[0]))) {
          this.$emit('input', [e[1], e[0]]);
        } else {
          this.$emit('input', [e[0], e[1]]);
        }
        this.isOpenMenu = false;
      }

      if (e.length === 0) {
        this.$emit('input', []);
      }
    }
  },
  watch: {
    modeSelection: {
      handler: function() {
        if (this.modeSelection === 'day') {
          this.date = [
            moment()
              .subtract(1, 'days')
              .format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ];
        } else if (this.modeSelection === 'week') {
          this.date = [
            moment()
              .subtract(1, 'weeks')
              .format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ];
        } else if (this.modeSelection === 'month') {
          this.date = [
            moment()
              .subtract(1, 'months')
              .format('YYYY-MM-DD'),
            moment().format('YYYY-MM-DD')
          ];
        }
        this.$emit('input', this.date);
      },
      immediate: true
    }
  },
  mounted() {
    this.maxDate = moment().format('YYYY-MM-DD');
  }
};
</script>
